// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"99f113f2","704":"dab12963"}[chunkId] + ".css";
};